<template>
    <b-modal id="changePasswordModal" title="Byt lösenord">
        <div>         
            <b-form-group>
                <label for="passwordText">Lösenord</label>
                <b-form-input 
                    type="password"
                    name="passwordText"
                    v-model.trim="$v.changePasswordRequest.newPassword.$model"
                  :class="{ 'is-invalid': $v.changePasswordRequest.newPassword.$anyError}"/>
              <b-form-invalid-feedback :state="$v.changePasswordRequest.newPassword.$anyError ? true : null">
                Detta fält är obligatoriskt
              </b-form-invalid-feedback>                     
            </b-form-group>
            <b-form-group>
                <label for="confirmedPassword">Bekräfta lösenord</label>
                <b-form-input 
                    type="password"
                    name="confirmedPassword"
                    v-model.trim="$v.changePasswordRequest.confirmedPassword.$model"
                  :class="{ 'is-invalid': !$v.changePasswordRequest.confirmedPassword.sameAsPassword}"/>
              <b-form-invalid-feedback :state="$v.changePasswordRequest.newPassword.$dirty ? $v.changePasswordRequest.confirmedPassword.sameAsPassword : null">
                Lösenorden måste vara samma
              </b-form-invalid-feedback>                     
            </b-form-group>
        </div>

      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="changePasswordClicked()" :disabled="saving">
          <b-spinner v-if="saving" class="mr-1" type="border" small />{{saving ? "Skickar" : "Ok" }}
        </b-button>
      </template>

    </b-modal> 
</template>

<script>
import { userService } from "../../../shared/services";
import { required, sameAs } from 'vuelidate/lib/validators'

export default {
    props: {
        userId: null
    },           
    data() {
        return {
            saving: false,
            changePasswordRequest : {
                newPassword : "",
                confirmedPassword: ""
            },              
        }        
    },
    validations: {
        changePasswordRequest: {
            newPassword: {
                required
            },
            confirmedPassword: {
                sameAsPassword: sameAs('newPassword')
            }
        }        
    },
    methods: {
        show() {
            this.changePasswordRequest.newPassword = "";
            this.changePasswordRequest.confirmedPassword = "";
            this.$bvModal.show("changePasswordModal");
        },
        changePasswordClicked() {

            this.$v.$touch();
            if(this.$v.$anyError) return;

            this.saving = true;
            userService.changePassword(this.userId, 
            this.changePasswordRequest.newPassword, this.changePasswordRequest.confirmedPassword).then(() => {
                this.saving = false;
                this.ShowToast("Ändrad", "Lösenordet ändrat", "success")

                this.$bvModal.hide("changePasswordModal");
                
            }).catch(p => {
                this.saving = false;
                this.ShowToast("Fel", "Ett okänt fel uppstod då lösenordet skulle ändras", "danger");
            });                
        }
    }
}
</script>

<style>

</style>
